export default __webpack_public_path__ + "static/media/category-marketing.b10a108e.jpg";